import React, { Component } from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'

export default class Photomanipulation extends Component {
    constructor(props){
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        
        return (
            <div className="row" id="body">
                    
            <div className="col-12 mx-0 col-lg-10" id="content">

                <div className="row pt-4" id="ui_design">
                    <div className="col-12 col-md-4 col-sm-6">
                      <img width="100%" id="mani0" src={require('../../../Images/Daily_project/Photo_manipulation/Mani_0.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 col-md-4 col-sm-6 pt-4 pt-sm-0">
                      <img width="100%" id="mani1" src={require('../../../Images/Daily_project/Photo_manipulation/Mani_1.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 col-md-4 col-sm-6 pt-4 pt-sm-0">
                      <img width="100%" id="mani2" src={require('../../../Images/Daily_project/Photo_manipulation/Mani_2.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 pt-4 pb-4">
                      <img width="100%" id="mani3" src={require('../../../Images/Daily_project/Photo_manipulation/Mani_3.png')} alt="Case_studies_2" />
                    </div>
                </div>
            </div>
                    
            <div className="col-lg-2 d-none d-lg-block px-4 pt-4 h-25 sticky-top" id="sidebar" style={{top: "56px"}}>

                <p className="h4">Project</p>
                <p>
                  <AnchorLink href="#mani0" className="bullet">Double exposure</AnchorLink>
                  <br />
                  <AnchorLink href="#mani1" className="bullet">Halloween</AnchorLink>
                  <br />
                  <AnchorLink href="#mani2" className="bullet">Fire snap</AnchorLink>
                  <br />
                  <AnchorLink href="#mani3" className="bullet">Space expo</AnchorLink>
                </p>
                <div className="row pt-4 px-3">
                <p className="h4">TOOLS</p>

                <div className="col-12 px-2">
                  <div className="row">
                          <img width="25%" className="tools" src={require('../../../Images/Tools/ps.png')} alt="Case_studies_1" />
                  </div>
                </div>
                
              </div>

            </div>
                  
            </div>
    )
}
}